import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      title="Privacy Policy"
      updated="December 7, 2026"
    >
      <p>
        AI Volta (&quot;AI Volta&quot;, &quot;we&quot;, &quot;our&quot;, or
        &quot;us&quot;) respects your privacy. This Privacy Policy explains
        what information we collect, how we use it, and the choices you have
        when you visit{" "}
        <span className="text-white">ai-volta.com</span> or engage with our
        services.
      </p>

      <Section title="1. Information We Collect">
        <p>
          We collect information you voluntarily provide when you fill out our
          contact form, book a free assessment, or otherwise communicate with
          us. This may include your name, email address, company, phone
          number, and any message details you share.
        </p>
        <p>
          We also collect limited analytics and usage data (such as IP
          address, browser type, pages viewed, and referrer) through
          privacy-respecting tools to understand how visitors interact with
          our site.
        </p>
      </Section>

      <Section title="2. How We Use Your Information">
        <ul className="list-disc pl-5 space-y-2">
          <li>To respond to inquiries and provide the services you request.</li>
          <li>To schedule and conduct free AI assessments and consultations.</li>
          <li>To improve our website, services, and content.</li>
          <li>To comply with legal obligations.</li>
        </ul>
      </Section>

      <Section title="3. Sharing of Information">
        <p>
          We do not sell your personal information. We may share limited
          information with trusted service providers (such as scheduling,
          email, and analytics tools) strictly to operate our business. These
          providers are bound by confidentiality obligations.
        </p>
      </Section>

      <Section title="4. Data Retention">
        <p>
          We retain contact submissions and related communications for as long
          as necessary to provide our services and for legitimate business or
          legal purposes. You may request deletion at any time by emailing us.
        </p>
      </Section>

      <Section title="5. Your Rights">
        <p>
          Depending on your location, you may have rights to access, correct,
          delete, or restrict the processing of your personal information. To
          exercise these rights, contact us at the email below.
        </p>
      </Section>

      <Section title="6. Security">
        <p>
          We use reasonable administrative, technical, and physical safeguards
          to protect your information. No method of transmission over the
          internet is 100% secure, and we cannot guarantee absolute security.
        </p>
      </Section>

      <Section title="7. Cookies">
        <p>
          We use a small number of cookies and similar technologies to operate
          the site and measure performance. You can control cookies through
          your browser settings.
        </p>
      </Section>

      <Section title="8. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. The updated
          version will be indicated by a revised &quot;Last updated&quot; date
          at the top of this page.
        </p>
      </Section>

      <Section title="9. Contact Us">
        <p>
          If you have any questions about this Privacy Policy, please contact
          us via the form on our homepage. AI Volta is based in Fort
          Lauderdale, FL.
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">
        {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
